<template>
    <div>
        <!--    <div id="my-container">-->
        <!--        <div :id="targetId" class="m-0 p-0 "><slot>&nbsp;</slot></div>-->

        <!-- Our popover title and content render container -->
        <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
        <!-- We specify the same container as the trigger button, so that popover is close to button -->
        <b-popover
            custom-class="toolbox-popover"
            :target="targetId"
            triggers="none"
            :show.sync="popoverShow"
            placement="right"
            ref="popover"
            @show="onShow"
            @shown="onShown"
            @hidden="onHidden"
        >
            <!--            container="my-container"-->
            <template #title>
                <b-button @click="onClose" class="close" aria-label="Close">
                    <span class="d-inline-block" aria-hidden="true">&times;</span>
                </b-button>
                Germany 2021 VAT Change ({{ taxPctFrom }}% to {{ taxPctTo }}%)
            </template>

            <div class="row">
                <div class="col-md-4 pb-2">
                    <b-list-group class="p-0 m-0">
                        <b-list-group-item v-for="scale in priceScales" :key="scale.price"
                                           class="py-1"
                                           button
                                           :active="scale.price === convertedPrice"
                                           @click="updatePriceFields(scale.price)"
                        >
                            {{ scale.price.toFixed(2) }}
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div class="col-md-8">
                    <b-form-group
                        label="Price"
                        label-for="popover-input-1"
                        label-cols="3"
                        :state="input1state"
                        class="mb-1"
                        description="Enter the list price"
                        invalid-feedback="This field is required"
                    >
                        <b-form-input
                            ref="input2"
                            id="popover-input-2"
                            v-model="input1"
                            :state="input1state"
                            size="sm"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Date"
                        label-for="popover-input-2"
                        label-cols="3"
                        :state="input2state"
                        class="mb-1"
                        description="Enter the data date"
                        invalid-feedback="This field is required"
                    >
                        <b-form-input
                            ref="input2"
                            id="popover-input-2"
                            v-model="input2"
                            :state="input2state"
                            size="sm"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Event"
                        label-for="popover-input-5"
                        label-cols="3"
                        :state="input5state"
                        class="mb-1"
                        description="Set the data event"
                        invalid-feedback="This field is required"
                    >
                        <b-form-select
                            id="popover-input-5"
                            v-model="input5"
                            :state="input5state"
                            :options="input5options"
                            size="sm"
                        ></b-form-select>
                    </b-form-group>

                    <b-alert :show="true" class="small">
                        <strong>New Values:</strong><br>
                        Price: <strong>{{ originalPrice.toFixed(2) }}</strong>
                        <span v-if="priceDiffPct" class="p-1 font-weight-bold" :class="priceDiffClass">{{ priceDiffPct}}%</span><br>
                        Expected: <strong>{{ convertedPrice.toFixed(2) }}</strong>
                        <span class="pl-1 text-danger">(max. {{ Math.round(originalPrice * (1 + (averagePriceIncrease/100))).toFixed(2) }})</span><br>
                        Date: <strong>{{ input2 }}</strong><br>
                        Event: <strong>{{ input5 }}</strong><br>
                        MY: <strong>{{ input6 }}</strong>
                    </b-alert>

                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <b-button @click="onClose" class="w-25" size="sm" variant="danger">Cancel</b-button>
                    <b-button @click="onOk" class="w-25" size="sm" variant="primary" :disabled="!input1">OK</b-button>
                </div>
            </div>
        </b-popover>
    </div>
</template>

<script>

// import baseGridMixin from '../BaseGridMixin';

export default {
    // mixins: ['baseGridMixin'],
    name: "Toolbox",
    props: {
        targetId: {
            type: String,
            required: true
        },
        storedData: {
            type: String|Number,
            default: null,
            required: true
        },
    },
    data() {
        return {
            taxDate: '2021-01-01',
            taxPctFrom: 16,
            taxPctTo: 19,
            input1: '',
            input1state: null,
            input1Return: '',
            input2: '',
            input2state: null,
            input2Return: '',
            input5: '',
            input5state: null,
            input5options: [{ text: 'Tax only', value: 'T' }, { text: 'Price only', value: 'P' }, { text: 'Model year', value: 'M' }],
            input5Return: '',
            input6: '',
            popoverShow: false,
        }
    },
    watch: {
        input1(val) {
            if (val) {
                this.input1state = true
            }
        },
        input2(val) {
            if (val) {
                this.input2state = true
            }
        },
        input5(val) {
            if (val) {
                this.input5state = true
                if (val === 'M') {
                    if (this.input2) {
                        this.input6 = parseInt(this.input2.split('-')[0])
                    }
                } else {
                    this.input6 = ''
                }
            }
        },
    },
    computed: {
        averagePriceIncrease: function () {
            // return Math.round((((this.taxPctTo - this.taxPctFrom) / (1 + (this.taxPctFrom/100))) + Number.EPSILON) / 10) * 10
            return Math.round((((this.taxPctTo - this.taxPctFrom) / (1 + (this.taxPctFrom/100))) + Number.EPSILON) * 10) / 10;
        },
        originalPrice: function () {
            return parseFloat(this.storedData.original);
        },
        convertedPrice: function () {
            let basePrice = this.originalPrice / (1 + ((this.taxPctFrom)/100));
            let newPrice =  basePrice * (1 + ((this.taxPctTo)/100));
            // return Math.round((newPrice + Number.EPSILON) * 100) / 100;
            return Math.round(newPrice);
        },
        priceDiffPct: function () {
          if (!this.input1) {
              return null;
          }
            return Math.round(((((this.input1 - this.originalPrice) / this.originalPrice) * 100) + Number.EPSILON) * 10)/10;
        },
        priceDiffClass: function () {
            if (Math.abs(this.priceDiffPct) > this.averagePriceIncrease + 0.2) {
                return 'text-danger';
            }
          return 'text-success';
        },
        priceScales: function () {
            // Build a list of possible new prices
            return [
                // { price: (Math.round(this.convertedPrice / 100) + 1) * 100},
                // { price: (Math.round(this.convertedPrice / 10) + 9) * 10},
                // { price: (Math.round(this.convertedPrice / 10) + 5) * 10},
                { price: (Math.round(this.convertedPrice / 10) + 1) * 10},
                { price: Math.round(this.convertedPrice + 5)},
                { price: Math.round(this.convertedPrice + 4)},
                { price: Math.round(this.convertedPrice + 3)},
                { price: Math.round(this.convertedPrice + 2)},
                { price: Math.round(this.convertedPrice + 1)},
                { price: this.convertedPrice },
                { price: Math.round(this.convertedPrice - 1)},
                { price: Math.round(this.convertedPrice - 2)},
                { price: Math.round(this.convertedPrice - 3)},
                { price: Math.round(this.convertedPrice - 4)},
                { price: Math.round(this.convertedPrice - 5)},
                { price: (Math.round(this.convertedPrice / 10) - 1) * 10},
                // { price: (Math.round(this.convertedPrice / 10) - 5) * 10},
                // { price: (Math.round(this.convertedPrice / 10) - 9) * 10},
                // { price: (Math.round(this.convertedPrice / 100) - 1) * 100},
            ]
        },
    },
    methods: {
        composePriceDataJSON(price) {
            if (!price) {
                return [];
            }

            let dataSet = [
                { prices__price_incl_tax: price.toFixed(2) },
            ];
            if (this.input2) {
                dataSet.push({ prices__data_date: this.input2});
            }
            if (this.input5) {
                dataSet.push({ prices__data_event: this.input5});
            }
            if (this.input6) {
                dataSet.push({ prices__model_year: this.input6});
            }

            return dataSet;
        },
        updatePriceFields(newPrice) {
            let formData = JSON.stringify(this.composePriceDataJSON(newPrice));
            this.$emit('update-grid', formData);
            this.popoverShow = false
        },
        onClose() {
            this.popoverShow = false
        },
        onOk() {
            if (this.input1 && this.input2 && this.input5) {
                let formData = JSON.stringify(this.composePriceDataJSON(parseFloat(this.input1)));
                this.$emit('update-grid', formData);
                this.onClose()
            }
        },
        onShow() {
            // This is called just before the popover is shown
            // Reset our popover form variables
            this.input1 = ''
            this.input1state = null
            this.input1Return = ''
            this.input2 = this.taxDate
            this.input2state = null
            this.input2Return = ''
            this.input5 = 'T'
            this.input2state = null
            this.input5Return = ''
            this.input6 = ''
        },
        onShown() {
            // Called just after the popover has been shown
            // Transfer focus to the first input
            this.focusRef(this.$refs.input1)
        },
        onHidden() {
            // Called just after the popover has finished hiding
            // Bring focus back to the button
            this.focusRef(this.$refs.button)
        },
        focusRef(ref) {
            // Some references may be a component, functional component, or plain element
            // This handles that check before focusing, assuming a `focus()` method exists
            // We do this in a double `$nextTick()` to ensure components have
            // updated & popover positioned first
            this.$nextTick(() => {
                this.$nextTick(() => {
                    // ref.focus()
                })
            })
        },

    }

}
</script>

<style scoped>

</style>
